import { Component, Input, OnInit } from '@angular/core';
import { ApplicantForm } from '../../forms/applicant.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';
import { DatePickerComponent } from '../../../../../../../common/date-picker/date-picker.component';

@Component({
  selector: 'app-applicant-no-nip-and-pesel-data-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ValidationErrorsComponent, DatePickerComponent],
  templateUrl: './applicant-no-nip-and-pesel-data-form.component.html'
})
export class ApplicantNoNipAndPeselDataFormComponent implements OnInit {
  @Input()
  public form: ApplicantForm | undefined;

  public ngOnInit(): void {
    this.form?.nip.disable();
    this.form?.pesel.disable();
    this.form?.name.disable();
    this.form?.regon.enable();
    this.form?.regon.setValidators([]);

    this.form?.firstName.enable();
    this.form?.lastName.enable();
    this.form?.fatherName.enable();
    this.form?.motherName.enable();
    this.form?.birthDate.enable();
  }
}
